;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Model = APP.module('Model');
	var checkboxFieldTemplate = JST.Checkbox;
	Model.Registration = Backbone.Model.extend({
		constructor: function(){
			this.validations = new Model.Validations();
			this.setSchemaValidation();
			Backbone.Model.apply(this, arguments);
		},
		setSchemaValidation: function(){
			this.schema = _.mapObject(this.schema, _.bind(function(value ,key){
				value.validators = this.validations.getValidationItems( value.validators ).length ? this.validations.getValidationItems( value.validators ): value.validators;
				return value;
			}, this));
		},
		url: function() {
			return this.methodUrl;
		},

		trackFormInput: function(field, value, id){
			let track_field = {
				user_key: id,
				field: field,
				value: value
			};
			return this.setApiUrl( 'user/registration_track' ).save({} , {data: track_field, ajaxSync: true});
		},

		extendSchema() {
			return this;
		},

		initialize() {
			this.extendSchema()
		},

		defaults: {
			first_name: '',
			last_name: '',
			email: '',
			password: '',
			birthday:  null,
			mobile: '',
			team_name: '',
			team_supported: 0,
			avatar: '',
			terms: 0,
			news: 1,
			disable_notifications: 1,
			weekly_results: '',
			weekly_reminders: '',
			fb_token: ''
		},
		schema: {
			first_name:{
				title: 'First name*',
				editorClass: 'first_name',
				editorAttrs: {
					maxlength: 45,
					placeholder: 'First Name:*'
				},
				validators:  ['first_name_required', 'first_name_regexp']
			},
			last_name:{
				title: 'Last name:*',
				editorClass: 'last_name',
				editorAttrs: {
					maxlength: 45,
					placeholder: 'Last name:*'
				},
				validators:  [ 'last_name_required', 'last_name_regexp']
			},
			email:{
				title: 'Email:*',
				editorClass: 'email',
				editorAttrs: {
					placeholder: 'Email:*',
					title: 'Your email will be used as your username when you log in'
				},
				validators:  ['email_validation', 'email_required']
			},
			confirm_email:{
				title: 'Confirm Email:*',
				editorClass: 'confirm_email',
				editorAttrs: {
					placeholder: 'Confirm Email:*'
				},
				validators: ['email_validation', 'email_required','email_match']
			},
			password:{
				type: 'Password',
				editorClass: 'password',
				editorAttrs: {
					minlength: 8,
					placeholder: 'Password:*'
				},
				validators:  ['password_required','password_regexp']
			},
			passwordConfirm:{
				type: 'Password',
				editorClass: 'passwordConfirm',
				editorAttrs: {
					placeholder: 'Password Confirm:*'
				},
				validators:  ['passwordConfirm_required','passwordConfirm_regexp', 'password_match']
			},
			birthday: {
				title: 'Birthday:*',
				type: 'Date',
				yearStart: 2013,
				yearEnd: 1916,
				validators:  ['birthday_required']
			},
			mobile: {
				title: 'Mobile:*',
				editorClass: 'mobile',
				editorAttrs: {
					maxlength: 15,
					minlength: 9,
					placeholder: 'Mobile:*'
				},
				validators:  ['mobile_required', 'mobile_is_number', 'mobile_length']
			},
			team_name:{
				title: 'Team name:*',
				editorAttrs: {
					maxlength: 40,
					placeholder: 'Team name:*'
				},
				validators: ['mobile_is_number', 'mobile_length']
			},
			team_supported: {
				title: 'Team Supported:*',
				editorClass: 'team_supported',
				type: 'Select',
				options: function(callback, editor) {
					var squads  = _.map(editor.form.data.squads , function(value){
						return {
							val: value.id,
							label: value.name
						}
					});
					callback(squads);
				},
				validators: ['team_supported_required']
			},
			terms: {
				type: 'Checkbox',
				title: 'I have read and accept the <a href="">Terms & Conditions</a>',
				options:{},
				template: checkboxFieldTemplate,
				validators: ['terms_required']
			},
			news: {
				type: 'Checkbox',
				title: 'I agree to receiving direct communication from the Australian Defence Force',
				options:{},
				template: checkboxFieldTemplate,
			},
			avatar: {
				type: "ImagePicker",
				//template: JST.ImageUploader,
				options:{
					button_text: ''
				}
			}
		}
	});

}(window, APP, Backbone, Marionette, $, _));


